import $ from 'jquery';



export class FinSessionApi {

	
	static renovarSession() {
		return $.ajax({
			url: "/api/dummy",
			statusCode: {
				401: function () {
					// Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = '/login';
				}
			}
		});
	}

	
}

